import { render, staticRenderFns } from "./credentials.vue?vue&type=template&id=22059e4f&scoped=true&"
import script from "./credentials.vue?vue&type=script&lang=js&"
export * from "./credentials.vue?vue&type=script&lang=js&"
import style0 from "./credentials.vue?vue&type=style&index=0&id=22059e4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22059e4f",
  null
  
)

export default component.exports